<template>
  <div class="box12" id="box12">
    <pageTitle
      title="技术学到位&nbsp;&nbsp;高薪offer就不难"
      text="据博学谷内部统计，0基础跨行学习软件测试的学生约占70%"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div class="content-box" @scroll="handleScroll">
      <div class="content" ref="content">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="age">年龄</div>
          <div class="education">学历</div>
          <div class="major">专业</div>
          <div class="work">学前职业</div>
          <div class="newSalay">现就业薪资</div>
          <div class="company">就业公司</div>
        </div>
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="age">{{ item.age }}</div>
          <div class="education">{{ item.education }}</div>
          <div class="major">{{ item.major }}</div>
          <div class="work">{{ item.work }}</div>
          <div class="newSalay">{{ item.newSalay }}</div>
          <div class="company">{{ item.company }}</div>
        </div>
      </div>
      <div class="seat"></div>
    </div>
    <div class="tip">
      数据来源：博学谷就业中心软件测试学科就业数据
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          name: "于**",
          age: "40",
          education: "本科",
          major: "光信科",
          work: "测试",
          newSalay: "28000",
          company: "保密",
        },
        {
          name: "冯**",
          age: "29",
          education: "本科",
          major: "软件工程",
          work: "Java开发",
          newSalay: "14900",
          company: "**外包",
        },
        {
          name: "史**",
          age: "31",
          education: "本科",
          major: "测控技术",
          work: "硬件测试",
          newSalay: "12500",
          company: "北京**科技",
        },
        {
          name: "王**",
          age: "29",
          education: "本科",
          major: "化学工程",
          work: "测试",
          newSalay: "12000",
          company: "保密",
        },
        {
          name: "黄**",
          age: "25",
          education: "本科",
          major: "计科",
          work: "在校生",
          newSalay: "12000",
          company: "**外包",
        },
        {
          name: "陈**",
          age: "30",
          education: "一本",
          major: "建筑学",
          work: "内容审核",
          newSalay: "12000",
          company: "**保险",
        },
        {
          name: "邢**",
          age: "29",
          education: "本科",
          major: "生物工程",
          work: "临床应用工程师",
          newSalay: "11800",
          company: "保密",
        },
        {
          name: "孙**",
          age: "26",
          education: "本科",
          major: "非计算机",
          work: "硬件测试",
          newSalay: "11000",
          company: "中**",
        },
        {
          name: "阮**",
          age: "27",
          education: "硕士",
          major: "建筑学",
          work: "建筑",
          newSalay: "10500",
          company: "南京**科技",
        },
        {
          name: "刘**",
          age: "30",
          education: "专科",
          major: "人力资源",
          work: "待业",
          newSalay: "10000",
          company: "保密",
        },
        {
          name: "续**",
          age: "26",
          education: "一本",
          major: "社会工作",
          work: "总裁助理",
          newSalay: "10000",
          company: "**共振",
        },
        {
          name: "郭**",
          age: "27",
          education: "本科",
          major: "计算机",
          work: "Java全栈开发",
          newSalay: "10000",
          company: "**科技",
        },
        {
          name: "孙**",
          age: "28",
          education: "二本",
          major: "计算机",
          work: "开发工程师",
          newSalay: "9500",
          company: "青岛**信息科技",
        },
        {
          name: "黄**",
          age: "30",
          education: "一本",
          major: "软件工程",
          work: "待业",
          newSalay: "9500",
          company: "中**外包",
        },
        {
          name: "徐**",
          age: "26",
          education: "本科",
          major: "计算机",
          work: "教师",
          newSalay: "9500",
          company: "保密",
        },
        {
          name: "陆**",
          age: "34",
          education: "本科",
          major: "计算机",
          work: "软件测试",
          newSalay: "9500",
          company: "广州**信息",
        },
        {
          name: "简**",
          age: "24",
          education: "本科",
          major: "机械",
          work: "Java后端开发",
          newSalay: "9500",
          company: "中**",
        },
        {
          name: "王**",
          age: "25",
          education: "本科",
          major: "计软",
          work: "技术支持",
          newSalay: "9500",
          company: "江苏**技术",
        },
        {
          name: "殷**",
          age: "25",
          education: "本科",
          major: "计软",
          work: "游戏测试",
          newSalay: "9208",
          company: "扇**",
        },
        {
          name: "胡**",
          age: "26",
          education: "专科",
          major: "计软",
          work: "销售",
          newSalay: "8500",
          company: "保密",
        },
        {
          name: "普**",
          age: "23",
          education: "本科",
          major: "计算机",
          work: "无线网络优化",
          newSalay: "8400",
          company: "**国际",
        },
        {
          name: "王**",
          age: "24",
          education: "本科",
          major: "计算机",
          work: "数据标注实习",
          newSalay: "8000",
          company: "****无锡电子",
        },
        {
          name: "刘**",
          age: "25",
          education: "本科",
          major: "软件工程",
          work: "待业",
          newSalay: "8000",
          company: "保密",
        },
        {
          name: "岳**",
          age: "23",
          education: "本科",
          major: "电子信息",
          work: "软件测试",
          newSalay: "8000",
          company: "深圳**能源科技",
        },
        {
          name: "毕**",
          age: "23",
          education: "本科",
          major: "商务英语",
          work: "人事",
          newSalay: "8000",
          company: "中电金**杭州",
        },
        {
          name: "王**",
          age: "24",
          education: "专科",
          major: "物联网",
          work: "客户经理",
          newSalay: "7500",
          company: "保密",
        },
        {
          name: "仲**",
          age: "24",
          education: "一本",
          major: "软件工程",
          work: "待业",
          newSalay: "7500",
          company: "江苏**息产业",
        },
        {
          name: "鲁**",
          age: "26",
          education: "本科",
          major: "计软",
          work: "英语辅导老师",
          newSalay: "7500",
          company: "保密",
        },
      ],
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  mounted() {},
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 30;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  position: relative;
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box12/bg.png")
    no-repeat;
  background-size: cover;
  overflow: hidden;

  .left-box {
    position: absolute;
    top: 240px;
    left: 0px;
    box-shadow: 8px 0px 16px 0px rgba(64, 128, 255, 0.06);
    div {
      width: 100%;
      height: 97px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      text-align: center;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
      box-sizing: border-box;
      &:first-child {
        background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
        font-size: 24px;
        font-family: PingFangSC-Medium;
        color: #1d2129;
        font-weight: 500;
        border-bottom: none;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .scorll-box {
    position: absolute;
    left: 50%;
    bottom: 144px;
    transform: translate(-50%, 0px);
    width: 40px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }

  .content-box {
    width: 100%;
    padding: 0px 0 0 32px;
    padding-bottom: 22px;
    overflow-x: auto;
    box-sizing: border-box;
    display: flex;
    .seat {
      width: 32px;
      flex-shrink: 0;
    }
  }
  .content-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .content {
    margin-top: 48px;
    width: 980px;
    flex-shrink: 0;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow-x: hidden;
    // overflow-y: scroll;

    .sex {
      width: 96px;
    }
    .age {
      width: 86px;
    }

    .major {
      width: 152px;
    }

    .education {
      width: 96px;
    }

    .name {
      width: 120px;
    }

    .work {
      width: 174px;
    }

    .newSalay {
      width: 154px;
    }

    .company {
      width: 178px;
    }

    .content-top {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: linear-gradient(180deg, #ceecff 0%, #f4faff 100%);
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      color: #1d2129;
    }

    .item {
      display: flex;
      width: 100%;
      height: 96px;
      line-height: 96px;
      text-align: center;
      border-radius: 24px 24px 0px 0px;
      background: #fff;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);

      .newSalay {
        color: #2ea5fc;
      }
    }
  }

  .tip {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #b9c8d9;
    line-height: 36px;
  }
}
</style>
